import { Steps as AntSteps } from 'antd';
import styled from 'styled-components';

import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const Description = styled(Text)`
  max-width: 50%;
`;

export const Steps = styled(AntSteps)`
  & .anticon-check {
    align-items: center;
    justify-content: center;
    display: flex;
    height: 100%;
  }

  & .ant-steps-finish-icon svg {
    fill: ${ColorEnum.White};
    height: 12px;
    margin-top: 2px;
  }

  .ant-steps-item-content {
    & .ant-steps-item-description {
      padding-top: 2px;
      font-size: 14px;
      color: ${ColorEnum.Black80} !important;
    }
  }

  .ant-steps-item-title {
    padding-left: 24px;
  }

  & .ant-steps-item-title::after {
    top: -6px;
  }

  & .ant-steps-item-wait {
    & .ant-steps-item-icon {
      background-color: ${ColorEnum.Black10};
      border-color: transparent;
    }

    & .ant-steps-icon {
      color: ${ColorEnum.Black30} !important;
    }
  }
`;
